import React, { useMemo } from "react";
import { OrderEntity } from "src/firebase/db/Orders";
import { BakedBreadEntity } from "src/firebase/db/BakedBreads";
import { UserEntity } from "src/firebase/db/Users";
import OrderListItem from "src/components/molecules/list/OrderListItem";
import { isReservation } from "src/helpers/OrderHelper";
import styled from "styled-components";

interface Props {
  isLoading: boolean;
  orders: OrderEntity[];
  bakedBreads: BakedBreadEntity[];
  filterByStatus: string;
  filterByPickup: boolean;
  filterByReserved: boolean;
  filterUsers: (order: OrderEntity) => UserEntity;
  filterPrevOrders: (order: OrderEntity) => OrderEntity[];
  onUpdateIsConfirmed: (id: string, isConfirmed: boolean) => void;
  onUpdateIsCompleted: (id: string, isCompleted: boolean) => void;
}

export const OrderList = ({ ...props }: Props) => {
  const {
    isLoading,
    orders,
    bakedBreads,
    filterByStatus,
    filterByPickup,
    filterByReserved,
    filterUsers,
    filterPrevOrders,
    onUpdateIsConfirmed,
    onUpdateIsCompleted,
  } = props;

  const filteredOrders = useMemo(() => {
    return orders.filter((order) => {
      const reservation = isReservation(order, bakedBreads);
      if (!filterByPickup && !reservation) {
        // 取り置き商品のチェックがない場合
        return false;
      }
      if (!filterByReserved && reservation) {
        // 予約商品のチェックがない場合
        return false;
      }
      switch (filterByStatus) {
        case "準備する商品を表示":
          return !order.is_confirmed;
        case "準備済の商品を表示":
          return order.is_confirmed;
        case "受渡済の商品を表示":
          return order.is_completed;
        case "すべての商品を表示":
          return true;
        default:
          return true;
      }
    });
  }, [orders, bakedBreads, filterByStatus, filterByPickup, filterByReserved]);

  if (!isLoading && !orders.length) {
    // TODO 0件の場合
    return (
      <Message>
        <label>お渡しが必要な注文はありません</label>
      </Message>
    );
  }

  if (!isLoading && !filteredOrders.length) {
    return (
      <Message>
        <label>条件に合う注文がありません</label>
        <p>別の検索方法をお試しください</p>
      </Message>
    );
  }

  return (
    <div>
      {orders.map((order) => (
        <OrderListItem
          key={order.id}
          order={order}
          bakedBreads={bakedBreads}
          user={filterUsers(order)}
          prevOrders={filterPrevOrders(order)}
          filterByStatus={filterByStatus}
          filterByPickup={filterByPickup}
          filterByReserved={filterByReserved}
          onUpdateIsConfirmed={onUpdateIsConfirmed}
          onUpdateIsCompleted={onUpdateIsCompleted}
        />
      ))}
    </div>
  );
};

const Message = styled.div`
  background-color: white;
  padding: 20px 0;
  text-align: center;
  border-radius: 4px;

  label {
    color: #ff0303;
    font-size: 18px;
    font-weight: bold;
    line-height: 18px;
  }

  p {
    margin-top: 16px;
    font-size: 14px;
    line-height: 17px;
  }
`;

export default OrderList;
